export default __webpack_public_path__ + "static/media/sygnet.41a88b5d.svg";